<template>
  <div
    v-if="hasBehaviourPrograms"
  >
    <hr-icon-action-btn
      icon="escalator_warning"
      size="md"
      @click="onSwitchBehaviourDialog"
    >
      <hr-badge
        v-if="draftData"
        :legacy-props="{color: 'secondary', rounded: true, floating: true,}"
      />
      <hr-tooltip v-if="draftData">
        {{ $t('common.availableDraft') }}
      </hr-tooltip>
    </hr-icon-action-btn>
  </div>
</template>
<script>

import BehaviourProgram from 'components/Programs/Behaviour/BehaviourProgram';
import { get } from 'lodash';
import { mapState } from 'pinia';
import { HrBadge, HrIconActionBtn, HrTooltip } from 'src/design-system';
import Interactions from 'src/mixins/Interactions';
import { auth } from 'src/store/auth';
import { programBehaviourData } from 'src/store/programBehaviourData';
import { programs } from 'src/store/programs';
import { sessions } from 'src/store/sessions';

export default {
  name: 'BehaviourProgramData',

  components: {
    HrBadge,
    HrIconActionBtn,
    HrTooltip,
  },

  mixins: [Interactions],

  props: {
    program: {
      type: Object,
      default: null,
    },
    color: {
      type: String,
      default: '',
    },
    session: {
      type: Object,
      required: false,
      default: null,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(programs, ['programs']),
    ...mapState(sessions, ['incidentHistory']),
    ...mapState(programBehaviourData, ['abcDraft']),
    ...mapState(auth, ['currentClient']),

    hasBehaviourPrograms() {
      return this.program !== null;
    },

    draftData() {
      return get(this.abcDraft, this.program?.client || null, null);
    }, // draftData()

  },

  methods: {

    onSwitchBehaviourDialog() {
      this.openComponentDialog(
        BehaviourProgram,
        {
          program: this.program,
          editData: this.draftData,
          session: this.session,
        },
      );
    }, // onSwitchBehaviourDialog()

  },
};
</script>
